import React, { Component } from 'react';

class Advantages extends Component {
	render() {
		return (            
            <section className="our-advantages">            
                <div className="container">
                    <header className="header header-main row">
                        <h2 className="col-md-12 text-left">Our Advantages</h2>
                    </header>            
                    <div className="row">
                        <div className="col-md-3">
                            <div className="item">
                                <h3>Golden 13 Years</h3>
                                <p>We have been renting out bicycles for almost 13 years</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="item">
                                <h3>Bike Repair</h3>
                                <p>Our bicycle mechanic can repair bikes within a day</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="item">
                                <h3>Free Service</h3>
                                <p>Tourists who want to cycle with a guide can join a daily bike ride</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="item">
                                <h3>Instant Help</h3>
                                <p>You can use booking form to rent a bike online</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
		);
	}
}

export default Advantages;


// WEBPACK FOOTER //
// ./src/Components/Advantages.js